import { errorCodes } from '@ourbranch/lookups';

// The backend refines the INVALIDVIN/5010 code via the rater pipeline's structured bracket metadata
// (`... [5010][{"lookupUnavailable":true}]`, built in @ourbranch/vehicle-data-client
// buildVinLookupFailureError). The payload arrives on the store error's `data` (object or JSON string
// depending on the path); a real no-hit carries none.
const vinLookupMetadata = (error) => {
  if (Number(error?.code) !== errorCodes.INVALIDVIN) {
    return null;
  }
  const payload = error?.data ?? error?.metadata;
  if (!payload) {
    return null;
  }
  try {
    return typeof payload === 'object' ? payload : JSON.parse(payload);
  } catch {
    return null;
  }
};

// A retryable vehicle-data outage: the VIN was never checked.
export const isVinLookupUnavailable = (error) => Boolean(vinLookupMetadata(error)?.lookupUnavailable);

// DataOne decoded the VIN, but our symbol table has no row for the vehicle (e.g. a brand-new nameplate
// like the 2027 Kia Telluride Hybrid). The VIN is fine; underwriting can hand-symbol the car.
export const isVinSymbolsNotFound = (error) => Boolean(vinLookupMetadata(error)?.symbolsNotFound);
